import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import rolodexLogo from './assets/rolodex.webp';
import { api } from './api';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');

    try {
      const response = await api.post('/v1/auth/forgot-password', { email });
      setMessage(response.data.message);
    } catch {
      setError('Unable to request a password reset right now. Please try again.');
    }
  };

  return (
    <div className="auth-screen" style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff', gap: 50 }}>
      <div className="auth-brand">
        <img src={rolodexLogo} alt="Digidex Logo" className="auth-logo" style={{ height: '7.5rem', width: '7.5rem', objectFit: 'contain' }} />
        <h1 style={{ fontSize: '2.15rem', fontWeight: 'bold', color: '#333' }}>Digidex</h1>
      </div>
      <form onSubmit={handleSubmit} className="auth-form" style={{ background: '#fff', padding: '2rem 2.5rem', borderRadius: '10px', boxShadow: '0 2px 16px rgba(0,0,0,0.07)', minWidth: '320px', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <h2 style={{ textAlign: 'center', marginBottom: '0.5rem', color: '#222' }}>Reset password</h2>
        <p style={{ margin: 0, color: '#555', textAlign: 'center' }}>Enter your account email and we’ll send reset instructions.</p>
        {error && <div style={{ color: 'red', textAlign: 'center' }}>{error}</div>}
        {message && <div style={{ color: 'red', textAlign: 'center' }}>{message}</div>}
        <input placeholder="Email" type="email" value={email} onChange={event => setEmail(event.target.value)} required style={{ padding: '0.75rem', border: '1px solid #ddd', borderRadius: '5px', fontSize: '1rem', background: '#fafafa', outline: 'none' }} />
        <button type="submit" style={{ padding: '0.75rem', border: 'none', borderRadius: '5px', background: '#222', color: '#fff', fontWeight: 'bold', fontSize: '1rem', cursor: 'pointer' }}>Send reset email</button>
        <Link to="/login" style={{ textAlign: 'center', color: '#222' }}>Back to login</Link>
      </form>
    </div>
  );
}

export default ForgotPassword;
